/* Two small post-render fixes that live outside variant-picker.js so they can
   be pushed to the store without repackaging the whole bundle.

   1. Relabels the savings badge from "-46%" to "Save 46%".
   2. Adds a third hardware state. The picker understands true/false; this
      adds "partial" for options where the board is only needed for some
      features (Movement needs it for Auto Armor Swap only). */
(function () {
  'use strict';

  /* ---------- 1. badge wording ---------- */
  function relabel(root) {
    (root || document).querySelectorAll('.badge-save').forEach(function (el) {
      var t = el.textContent.trim();
      if (/^save/i.test(t)) return;
      var m = t.match(/(\d+)\s*%/);
      if (m) el.textContent = 'Save ' + m[1] + '%';
    });
  }

  /* ---------- 2. hardware notice states ---------- */
  var PARTIAL = {};   // option value -> copy

  function readConfig() {
    var el = document.querySelector('[data-hardware-partial]');
    if (!el) return;
    try { PARTIAL = JSON.parse(el.textContent) || {}; }
    catch (e) { PARTIAL = {}; }
  }

  function currentOptionValues() {
    var out = [];
    document.querySelectorAll('[data-option-input]:checked').forEach(function (i) {
      out.push(i.value);
    });
    document.querySelectorAll('[data-option-select]').forEach(function (s) {
      out.push(s.value);
    });
    return out;
  }

  function applyHardware() {
    var notice = document.querySelector('[data-hardware-notice]');
    if (!notice) return;

    var match = null;
    currentOptionValues().forEach(function (v) {
      if (Object.prototype.hasOwnProperty.call(PARTIAL, v)) match = v;
    });

    notice.classList.remove('notice--partial');

    if (!match) return;   // leave the picker's own required/not-required styling

    var cfg = PARTIAL[match];
    var title = notice.querySelector('[data-hardware-title]');
    var body  = notice.querySelector('[data-hardware-body]');
    var icon  = notice.querySelector('[data-hardware-icon]');

    notice.classList.remove('notice--ok');
    notice.classList.add('notice--partial');
    if (icon) icon.textContent = '!';
    if (title) title.textContent = cfg.title || 'Hardware needed for some features';
    if (body) body.innerHTML = cfg.body || '';
  }

  function start() {
    readConfig();
    relabel();
    applyHardware();

    var host = document.querySelector('[data-variant-picker]');
    if (host && window.MutationObserver) {
      new MutationObserver(function () { relabel(host); }).observe(host, { childList: true, subtree: true });
      host.addEventListener('change', function () { setTimeout(applyHardware, 0); });
      host.addEventListener('click', function () { setTimeout(applyHardware, 0); });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
